// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__oTiZW","question":"Question_question__1okOv","description":"Question_description__315lI"};